import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { VentaService } from '../../services/venta.service';
import { TranslateService } from 'src/app/shared/services/translate.service';
import { AlbaranItemDialog, AlbaranPausadoDetail, IKoreTarifaDisponible, ITiendaRestItemDialog, VentaPausadaGet } from 'src/app/modules/gestionar-pausadas/interfaces/gestionar-pausadas.interface';
import { VentaPausadaService } from 'src/app/modules/gestionar-pausadas/services/venta-pausada.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SuccessToast } from 'src/app/core/toast/success.toast';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { ConfigurationService } from 'src/app/core';


export interface DialogSalePauseDetailData {
  ventapausada: VentaPausadaGet;
}

export interface DialogSalePauseDetailResult {
  confirm: boolean;
  tag: string;
}

@Component({
  selector: 'dialog-sale-pause-detail',
  templateUrl: 'dialog-sale-pause-detail.component.html',
  styleUrls: ['./dialog-sale-pause-detail.component.scss'],
})
export class DialogSalePauseDetailComponent implements OnInit {
  showMsgError: boolean = false;
  showForm = false;

  ventaPausadaInfo: AlbaranPausadoDetail;
  albaranItems: AlbaranItemDialog[] = [];
  tiendaRestItems: ITiendaRestItemDialog[] = [];
  espectaculosItems: AlbaranItemDialog[] = [];

  subAlbaranPausado: Subscription;

  loading = false;


  divisaSimboloDecimal: string; 
  divisaSimbSeparacionMiles: string;  
  divisaSimbolo: string;
  divisaDecimales: number;
  divisaPosicion: string;
  divisaSimboloDerecha: string;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogSalePauseDetailComponent>,
    private ventaService: VentaService,
    private translateService: TranslateService,
    private ventaPausadaService: VentaPausadaService,
    private toastService: ToastrService,
    private configurationService: ConfigurationService,
    @Inject(MAT_DIALOG_DATA) public data: DialogSalePauseDetailData
  ) {
    console.log({
      dataReceived: data
    });

    //For Test
    this.showForm = true;

    this.loading = true;

    this.subAlbaranPausado = this.ventaPausadaService.getVentaPausadaDetail(data.ventapausada).subscribe(
      (res) => {

        console.log({
          action: 'getVentaPausadaDetail',
          res: res
        })

        this.loading = false;

        if (!res) {

          this.toastService.success(
            this.translateService.instant('ERROR_AVISAR_ENCARGADO'),
            '',
            {
              toastComponent: ErrorToast,
            }
          );

          this.dialogRef.close({
            confirm: false,
            tag: ''
          });

        }


        this.ventaPausadaInfo = res;

        /*
          Se incluirán los siguientes atributos de salida para poder diferenciar entre:
          VISITAS (TipoElemento = 1; CategoriaId > 0; EspectaculoId = 0)
          ESPECTÁCULOS (TipoElemento = 1; CategoriaId > 0, EspectaculoId > 0)
          TIENDA (TipoElemento = 2; CategoriaId > 0)
          RESTAURACION (TipoElemento = 2; CategoriaId > 0)
        
        */

        if (this.ventaPausadaInfo && this.ventaPausadaInfo.albaranItems) {
          for (const item of this.ventaPausadaInfo.albaranItems) {

            let tarifaDisponible: IKoreTarifaDisponible | null = null;

            if (item.tipoElemento === 1) {
              // VISITAS o ESPECTÁCULOS
              if (item.categoriaId > 0 && item.espectaculoId > 0) {
                console.log({
                  item: item,
                  tipo: 'ESPECTÁCULO'
                })
              } else if (item.categoriaId > 0) {
                console.log({
                  item: item,
                  tipo: 'VISITA'
                });
                
                this.ventaPausadaService.getInfoTarifaVisitaEspectaculo(item)
                  .subscribe((tarifa) => {
                    if (tarifa) {
                      this.albaranItems.push({
                        ...item,
                        tarifaDisponible: tarifa
                      })
                      console.log({
                        action: 'get info tarifas',
                        items: this.albaranItems
                      })
                    }
                  }, (error) => {
                    console.error({
                      action: 'getInfoTarifaVisitaEspectaculo',
                      error: error
                    });
                  });
              }
            } else if ((item.tipoElemento === 2 || item.tipoElemento === 3) && item.categoriaId > 0) {
              // TIENDA o RESTAURACIÓN
              console.log({
                item: item,
                tipo: 'TIENDA o RESTAURACIÓN'
              });
              
              this.ventaPausadaService.getInfoTarifaTiendaRestauracion(item)
                .subscribe((entrada) => {
                  if (entrada) {
                    this.tiendaRestItems.push({
                      ...item,
                      entrada: entrada
                    })
                    console.log({
                      action: 'get info tienda restauración',
                      items: this.tiendaRestItems
                    })
                  }
                }, (error) => {
                  console.error({
                    action: 'getInfoTarifaTiendaRestauracion',
                    error: error
                  });
                });
            }
          }
        }
      },
      (error) => {
        console.error({
          action: 'getVentaPausadaDetail',
          error: error
        });
        this.loading = false;
      }
    );

  }

  getPrecioTotalPorItem(item: AlbaranItemDialog | ITiendaRestItemDialog): number {
    const precioTotal = item.precioTotal || 0;
    const cantidad = item.cantidad || 1;
    return Number(precioTotal) * Number(cantidad);
  }

  getCantidadDeItems() {
    const itemsVisitas = this.albaranItems.length;
    const itemsTiendaRest = this.tiendaRestItems.length;
    const itemsEspectaculos = this.espectaculosItems.length;
    return itemsVisitas + itemsTiendaRest + itemsEspectaculos;
  }

  getPrecioFinalTotal(): number {
    return this.ventaPausadaInfo.totalPagar || 0;
  }

  ngOnInit() {
    this.divisaSimbSeparacionMiles = this.configurationService.divisasValue[0].SimbSeparacionMiles;
    this.divisaSimboloDecimal = this.configurationService.divisasValue[0].SimboloDecimal;
    this.divisaSimbolo = this.configurationService.divisasValue[0].simbolo;
    this.divisaDecimales = Number(this.configurationService.divisasValue[0].NumeroDecimales)
    this.divisaPosicion = this.configurationService.divisasValue[0].PosicionDivisa;
    this.divisaSimboloDerecha = this.configurationService.divisasValue[0].SimboloDerecha;
  }

  onNoClick() {

    if (this.subAlbaranPausado) {
      this.subAlbaranPausado.unsubscribe();
    }

    this.dialogRef.close({
      confirm: false,
      tag: ''
    });
  }

  confirm() {
    this.dialogRef.close({
      confirm: true,
      tag: '123'
    });
  }

}
